import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#000000",
    "col1s": "#4F4F4F"
}
function AccHat168({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M.3 18.2l.05.05Q-.9 20.2 2.05 23.5l55.7 55.95q3.25 2.9 5.45 1.05l.15-.15-.05-.05q1.45-2.15-1.2-5.2L6.35 19.15q-3.5-3.2-5.6-1.4l-.2.2-.25.25m79.8 13.4Q67.85 14.85 52 2.7q-5.3-4.6-10.2-1.4L12.35 25.15 55.9 68.8l22.95-28.05q3.9-4.2 1.25-9.15z"
                    id="AccHat168__Symbol_559_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1s}
                    d="M43.55 45.3l1.65-2.05L1.95 0 0 1.65 43.55 45.3z"
                    id="AccHat168__Symbol_558_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#AccHat168__Symbol_559_0_Layer0_0_FILL"
                transform="translate(225.25 41.1)"
                id="AccHat168__col1n"
            />
            <use
                xlinkHref="#AccHat168__Symbol_558_0_Layer0_0_FILL"
                transform="translate(237.6 64.6)"
                id="AccHat168__col1s"
            />
        </g></g>
    )
}
export default AccHat168
